/**
 * Pismo/jezik opcija (znakovi-zastite): Latinica / Ćirilica / English-Multilingual-Izmena.
 * Sve tri vrednosti sada upisuju liniju u napomenu porudžbine (properties[...]),
 * ne samo treće dugme kao ranije:
 *  - Latinica  -> properties[Pismo] = "Latinica: <naziv proizvoda>"
 *  - Ćirilica  -> properties[Pismo] = "Ćirilica: <naziv proizvoda transliterovan>"
 *                 (deterministička SR latinica->ćirilica mapa, bez spoljnih podataka)
 *  - 3. dugme  -> properties[Tekst na znaku] = uređivo polje, prefill iz
 *                 product.metafields.custom.tekst_engleski (prazno dok se ne popuni)
 *
 * Vrednost ide kao Shopify line item property preko postojeće forme
 * (form="...") — ne duplira formu, vidljivo u detaljima porudžbine.
 * Event delegation (change na document) umesto Dawn pub-sub sistema.
 */
(function () {
  var CYRILLIC_MAP = [
    ['Nj', 'Њ'], ['NJ', 'Њ'], ['nj', 'њ'],
    ['Lj', 'Љ'], ['LJ', 'Љ'], ['lj', 'љ'],
    ['Dž', 'Џ'], ['DŽ', 'Џ'], ['dž', 'џ'],
    ['A', 'А'], ['B', 'Б'], ['V', 'В'], ['G', 'Г'], ['D', 'Д'], ['Đ', 'Ђ'],
    ['E', 'Е'], ['Ž', 'Ж'], ['Z', 'З'], ['I', 'И'], ['J', 'Ј'], ['K', 'К'],
    ['L', 'Л'], ['M', 'М'], ['N', 'Н'], ['O', 'О'], ['P', 'П'], ['R', 'Р'],
    ['S', 'С'], ['T', 'Т'], ['Ć', 'Ћ'], ['U', 'У'], ['F', 'Ф'], ['H', 'Х'],
    ['C', 'Ц'], ['Č', 'Ч'], ['Š', 'Ш'],
    ['a', 'а'], ['b', 'б'], ['v', 'в'], ['g', 'г'], ['d', 'д'], ['đ', 'ђ'],
    ['e', 'е'], ['ž', 'ж'], ['z', 'з'], ['i', 'и'], ['j', 'ј'], ['k', 'к'],
    ['l', 'л'], ['m', 'м'], ['n', 'н'], ['o', 'о'], ['p', 'п'], ['r', 'р'],
    ['s', 'с'], ['t', 'т'], ['ć', 'ћ'], ['u', 'у'], ['f', 'ф'], ['h', 'х'],
    ['c', 'ц'], ['č', 'ч'], ['š', 'ш']
  ];

  function toCyrillic(text) {
    var result = text;
    CYRILLIC_MAP.forEach(function (pair) {
      result = result.split(pair[0]).join(pair[1]);
    });
    return result;
  }

  function selectedValuesOf(buybox) {
    var values = [];
    buybox.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      values.push(r.value);
    });
    buybox.querySelectorAll('select').forEach(function (s) {
      var opt = s.options[s.selectedIndex];
      if (opt) values.push(opt.textContent);
    });
    return values;
  }

  function matchesKeyword(values, keywords) {
    return values.some(function (v) {
      var lower = v.toLowerCase();
      return keywords.some(function (k) { return lower.indexOf(k) !== -1; });
    });
  }

  function checkAndToggle(buybox) {
    var wrap = buybox.querySelector('.pdp-pismo-note');
    if (!wrap) return;

    var title = wrap.dataset.productTitle || '';
    var hiddenInput = wrap.querySelector('.pdp-pismo-hidden-value');
    var preview = wrap.querySelector('.pdp-pismo-preview');
    var customNote = wrap.querySelector('.pdp-custom-text-note');
    var values = selectedValuesOf(buybox);

    var isLatin = matchesKeyword(values, ['latinic']);
    var isCyrillic = matchesKeyword(values, ['ćirilic', 'cirilic', 'ćirilica']);
    var isCustom = customNote
      ? matchesKeyword(values, (customNote.dataset.optionKeyword || '').toLowerCase().split('|').filter(Boolean))
      : false;

    if (isLatin && hiddenInput) {
      hiddenInput.value = 'Latinica: ' + title;
    } else if (isCyrillic && hiddenInput) {
      hiddenInput.value = 'Ćirilica: ' + toCyrillic(title);
    } else if (hiddenInput) {
      hiddenInput.value = '';
    }

    if (preview) {
      if (isLatin) {
        preview.hidden = false;
        preview.textContent = 'Znak će biti odštampan: ' + title;
      } else if (isCyrillic) {
        preview.hidden = false;
        preview.textContent = 'Znak će biti odštampan: ' + toCyrillic(title);
      } else {
        preview.hidden = true;
        preview.textContent = '';
      }
    }

    if (customNote) {
      var input = customNote.querySelector('textarea, input');
      if (isCustom) {
        customNote.hidden = false;
        if (input && !input.value && input.dataset.defaultText) {
          input.value = input.dataset.defaultText;
        }
      } else {
        customNote.hidden = true;
        if (input) input.value = '';
      }
    }
  }

  document.addEventListener('change', function (e) {
    var buybox = e.target.closest('.pdp-buybox');
    if (buybox) checkAndToggle(buybox);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pdp-buybox').forEach(checkAndToggle);
  });
})();
